import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useGame } from '../contexts/GameContext';
const Collectible = ({
  id,
  x,
  y
}) => {
  const {
    collectStar,
    collectedStars,
    playerPosition
  } = useGame();
  const [visible, setVisible] = useState(true);
  const [isCollecting, setIsCollecting] = useState(false);
  const [particles, setParticles] = useState([]);
  const collisionRadius = 40; // Distance for collision detection
  // Check if star is already collected
  useEffect(() => {
    if (collectedStars.includes(id)) {
      setVisible(false);
    }
  }, [collectedStars, id]);
  // Check for collision with player
  useEffect(() => {
    if (!visible || isCollecting) return;
    const distance = Math.sqrt(Math.pow(playerPosition.x - x, 2) + Math.pow(playerPosition.y - y, 2));
    if (distance < collisionRadius) {
      handleCollection();
    }
  }, [playerPosition, visible, isCollecting, x, y]);
  // Handle collection with animation
  const handleCollection = () => {
    if (isCollecting) return;
    setIsCollecting(true);
    // Create particle explosion
    const newParticles = Array.from({
      length: 12
    }, (_, i) => ({
      id: i,
      angle: i * 360 / 12,
      distance: Math.random() * 50 + 30
    }));
    setParticles(newParticles);
    // Collect star after animation
    setTimeout(() => {
      collectStar(id);
      setVisible(false);
    }, 800);
  };
  if (!visible) return null;
  return <>
      {/* Main Star */}
      <motion.div className="absolute pointer-events-none" style={{
      left: x,
      top: y
    }} initial={{
      scale: 0,
      rotate: 0
    }} animate={isCollecting ? {
      scale: [1, 1.5, 0],
      rotate: 360,
      y: -100,
      opacity: [1, 1, 0]
    } : {
      scale: [1, 1.2, 1],
      rotate: [0, 5, -5, 0],
      y: [0, -10, 0]
    }} transition={isCollecting ? {
      duration: 0.8,
      ease: 'easeInOut'
    } : {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-36">
        {/* Glow effect */}
        <motion.div className="absolute inset-0 rounded-full" style={{
        background: 'radial-gradient(circle, rgba(255, 215, 0, 0.6) 0%, transparent 70%)',
        width: '60px',
        height: '60px',
        left: '-10px',
        top: '-10px'
      }} animate={{
        scale: [1, 1.5, 1],
        opacity: [0.5, 0.8, 0.5]
      }} transition={{
        duration: 1.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-37" />
        {/* Star SVG */}
        <svg width="40" height="40" viewBox="0 0 24 24" style={{
        filter: 'drop-shadow(0 0 10px rgba(255, 215, 0, 0.8))'
      }} data-id="element-38">
          <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" fill="#FFD700" data-id="element-39" />
        </svg>
      </motion.div>
      {/* Particle Explosion */}
      <AnimatePresence data-id="element-40">
        {isCollecting && particles.map(particle => <motion.div key={particle.id} className="absolute w-2 h-2 rounded-full bg-yellow-400" style={{
        left: x,
        top: y
      }} initial={{
        scale: 1,
        opacity: 1
      }} animate={{
        x: Math.cos(particle.angle * Math.PI / 180) * particle.distance,
        y: Math.sin(particle.angle * Math.PI / 180) * particle.distance,
        scale: 0,
        opacity: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-41" />)}
      </AnimatePresence>
      {/* Collection Text */}
      <AnimatePresence data-id="element-42">
        {isCollecting && <motion.div className="absolute text-yellow-400 font-bold text-xl pointer-events-none" style={{
        left: x,
        top: y - 20
      }} initial={{
        opacity: 0,
        y: 0,
        scale: 0.5
      }} animate={{
        opacity: 1,
        y: -50,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -80
      }} transition={{
        duration: 0.8
      }} data-id="element-43">
            +1 ⭐
          </motion.div>}
      </AnimatePresence>
    </>;
};
export default Collectible;